<template>
  <div class="flex-container">
    <div class="flex-header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>商户管理</el-breadcrumb-item>
        <el-breadcrumb-item>商户列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-form :inline="true" size="mini" :model="searchForm" class="search-form">
      <el-form-item label="搜索词：">
        <el-input v-model="searchForm.keyword" clearable placeholder="请输入商户名称/信用代码/门店名称/门店编号" style="width:280px;" />
      </el-form-item>
      <el-form-item label="所属渠道:" v-if="userRole === '4'">
        <el-select
            v-model="searchForm.channelId"
            placeholder="请选择渠道"
            clearable
            filterable
            style="width: 280px"
        >
          <el-option
              v-for="item in channelList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="申报类型:">
        <el-select v-model="searchForm.wfType" placeholder="请选择" clearable style="width:140px">
          <el-option value="1" label="渠道遴选" />

          <!-- wf_type='2' 细分 -->
          <el-option value="2" label="新增商户/门店" />
          <el-option value="2-1" label="老商户新增门店" />

          <!-- wf_type='3' -->
          <el-option value="3" key="3" label="退出门店" />

          <!-- wf_type='4' 细分 -->
<!--          <el-option value="4" label="修改商户/门店" />-->
          <el-option value="4-2" label="修改商户" />
          <el-option value="4-1" label="修改门店" />
        </el-select>
      </el-form-item>
      <el-form-item label="审核状态:">
        <el-select v-model="searchForm.status" placeholder="请选择" clearable style="width:140px">
          <el-option value="reviewing" label="审核中" />
          <el-option value="approve" label="通过" />
          <el-option value="reject" label="不通过" />
        </el-select>
      </el-form-item>
      <el-form-item label="时间筛选:">
        <el-select
          v-model="searchForm.timeField"
          placeholder="请选择时间字段"
          clearable
          style="width: 120px"
        >
          <el-option label="创建时间" value="create_time" />
          <el-option label="挂网时间" value="join_date" />
          <el-option label="流程时间" value="wf_create_time" />
        </el-select>
        <span style="margin:0 4px;color:#909399">~</span>
        <el-date-picker
            v-model="searchForm.startTime"
            type="date"
            placeholder="开始日期"
            size="mini"
            value-format="yyyy-MM-dd"
            style="width: 140px"
        />
        <span style="margin:0 4px;color:#909399">至</span>
        <el-date-picker
            v-model="searchForm.endTime"
            type="date"
            placeholder="结束日期"
            size="mini"
            value-format="yyyy-MM-dd"
            style="width: 140px"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
        <el-button @click="onReset">重置</el-button>
        <el-button type="primary" @click="handleExport" v-if="userRole !== '4'">导出</el-button>
      </el-form-item>
    </el-form>

    <div class="flex-item table-wrapper">
      <el-table
          :key="tableKey"
          ref="multipleTable"
          :data="tableData"
          border
          size="small"
          style="width:100%;"
          v-loading="tableLoading"
          :height="tableHeight"
          row-key="uniqueKey"
          lazy
          :load="loadNode"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column label="序号" width="100" align="left">
          <template slot-scope="scope">
            {{ getRowIndex(scope.$index, scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="channelName" label="渠道名称" min-width="160" show-overflow-tooltip />
        <el-table-column prop="merchantName" label="商户/门店名称" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <!-- 滚动加载更多占位行 -->
            <div v-if="scope.row.isLoadMore" class="load-more-cell" @click="loadMoreStores(scope.row)">
              <span v-if="scope.row.loading" class="load-more-text"><i class="el-icon-loading" /> 加载中...</span>
              <span v-else class="load-more-text">
                <i class="el-icon-arrow-down" /> 已加载 {{ scope.row.loadedCount }} 条，点击加载更多
                <div :ref="'sentinel_' + scope.row.merchantId" class="sentinel" />
              </span>
            </div>
            <!-- 普通行：商户名 + 曾用名 -->
            <div v-else class="merchant-name-cell">
              <span>{{ scope.row.merchantName || '-' }}</span>

              <!-- 计算曾用名列表并判断是否有非空 -->
              <el-tooltip
                  v-if="getAliasNames(scope.row.merchantAllName, scope.row.merchantName).length > 0"
                  :content="'曾用名：' + getAliasText(scope.row.merchantAllName, scope.row.merchantName)"
                  placement="top"
                  effect="light"
              >
                <el-tag size="mini" type="info" class="alias-tag">曾用名</el-tag>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="merchantCreditCode" label="信用代码/门店编号" min-width="160" align="center" show-overflow-tooltip />
        <el-table-column prop="dataType" label="申报类型" min-width="100" align="center" show-overflow-tooltip >
          <template slot-scope="scope">
            <span>{{ getWfTypeText(scope.row.dataType) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="auditState" label="审核状态" width="180" align="center">
          <template slot-scope="scope">
            <div class="audit-state-group">
              <el-tag :type="merchantAuditStateTagType(scope.row.auditState)" size="mini">
                {{ merchantAuditStateText(scope.row.auditState) }}
              </el-tag>
              <span v-if="['4', '7'].includes(scope.row.auditState) && scope.row.latestAuditState" style="color:#909399;font-size:12px;margin-left:4px;">终态：{{ merchantAuditStateText(scope.row.latestAuditState) }}</span>
              <el-tooltip
                  v-if="['4', '7'].includes(scope.row.auditState)"
                  popper-class="audit-tooltip-popper"
                  effect="light"
                  placement="top"
                >
                  <div slot="content" class="audit-tip-plain" v-html="formatAuditDesc(scope.row)"></div>
                  <i class="el-icon-warning" style="margin-left:4px;color:#E6A23C;cursor:pointer;" />
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="140" align="center" >
          <template slot-scope="scope">
            {{ formatTime(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="joinDate" label="挂网时间" width="100" align="center" />
        <el-table-column prop="saleModel" label="经营模式" width="80" align="center" v-if="userRole === '4'">
          <template slot-scope="scope">
            <span>{{ scope.row.saleModel || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="region" label="所属地区" width="100" align="center" show-overflow-tooltip />
        <el-table-column prop="regLocation" label="注册地址" min-width="150" show-overflow-tooltip />
        <el-table-column prop="groupName" label="所属集团" min-width="150" show-overflow-tooltip />
        <el-table-column prop="scale" label="企业规模" min-width="80" align="center" show-overflow-tooltip />
        <el-table-column prop="ownership" label="企业性质" min-width="80" align="center" show-overflow-tooltip />
        <el-table-column prop="contact" label="联系人" min-width="80" align="center" show-overflow-tooltip />
        <el-table-column prop="contactPhone" label="联系人电话" min-width="100" align="center" show-overflow-tooltip />
        <el-table-column prop="applyExitDate" label="退出时间" width="100" align="center" />
        <el-table-column prop="isCount" label="是否纳统" width="80" align="center" />
        <el-table-column label="操作" align="center" min-width="100px" fixed="right">
          <template slot-scope="scope">
            <el-button @click.native.prevent="viewMerchant(scope.row)" type="text" size="small" v-if="!scope.row.isStore">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-bar">
      <el-pagination
          :key="paginationKey"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      />
    </div>
  </div>
</template>

<script>
import { pageQueryList, subPageQuery, exportExcel} from "@/api/system/merchant";
import { channelDict } from "@/api/system/channel";
import * as util from "@/assets/js/util";

const wfTypeMap = {
  '1': '渠道遴选',
  '2': '新增商户/门店',
  '2-1': '新增门店',
  '3': '退出商户/门店',
  '4': '修改商户/门店',
  '4-1': '修改门店',
  '4-2': '修改商户'
};

export default {
  name: "merchantManageList",
  data() {
    return {
      paginationKey: 0, // 用于强制刷新分页组件
      userRole: '',
      channelId: '',
      channelList: [],
      tableData: [],
      tableLoading: false,
      tableHeight: '400px',
      tableKey: 0,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      keyCounter: 0,
      searchForm: { keyword: '', channelId: '', wfType: '', status: '', timeField: '', startTime: '', endTime: '' },
      storePageMap: {}, // 门店分页状态：{ [merchantId]: { pageNo, pageSize, total, hasMore } }
      observerMap: {},  // 滚动加载观察器：{ [merchantId]: IntersectionObserver }
    };
  },
  created() {
    this.userRole = util.session("userRole") && util.session("userRole").userRole || '';
    // 加载渠道下拉字典，完成后从路由 query 恢复搜索条件再查询
    channelDict().then(res => {
      if (res && res.code === '200') {
        this.channelList = res.data || [];
      }
    }).finally(() => {
      const query = this.$route.query
      if (query.keyword)   this.searchForm.keyword = query.keyword || ''
      if (query.channelId) this.searchForm.channelId = query.channelId || ''
      if (query.wfType)    this.searchForm.wfType = query.wfType || ''
      if (query.status)    this.searchForm.status = query.status || ''
      if (query.timeField) this.searchForm.timeField = query.timeField || ''
      if (query.startTime) this.searchForm.startTime = query.startTime || ''
      if (query.endTime)   this.searchForm.endTime = query.endTime || ''
      if (query.currentPage)  this.currentPage = parseInt(query.currentPage) || 1
      if (query.pageSize)     this.pageSize    = parseInt(query.pageSize)    || 10
      this.fetchList();
    });
  },
  mounted() {
    this.setTableHeight();
  },
  beforeDestroy() {
    Object.values(this.observerMap).forEach(obs => obs && obs.disconnect());
  },
  methods: {
    getWfTypeText(type) { return wfTypeMap[type] || '-'; },
    formatAuditDesc(row) {
      // 1. 根据审核状态选择对应的描述字段和 wf 字段
      const isFirst = row.auditState === '4';
      const rawDesc = isFirst ? row.firstAuditDesc : row.secondAuditDesc;
      const wfDesc = isFirst ? row.wfFirstAuditDesc : row.wfSecondAuditDesc;

      // 2. 如果 wfDesc 有值，且 rawDesc 中不包含它，则将其添加到最前面
      let finalDesc = rawDesc || '';
      if (wfDesc && wfDesc.trim() !== '') {
        // 判断 rawDesc 是否包含 wfDesc（可去除首尾空白后比较）
        const wfTrimmed = wfDesc.trim();
        if (!finalDesc.includes(wfTrimmed)) {
          // 如果原描述不为空，则用换行符分隔；否则直接使用 wfDesc
          finalDesc = finalDesc ? `${wfTrimmed}\n${finalDesc}` : wfTrimmed;
        }
      }

      // 3. 按原有逻辑处理换行、去空白、过滤空行，并拼接为 <br>（用于 HTML 渲染）
      if (!finalDesc) return '';
      return finalDesc
          .split(/\r?\n/)
          .map(line => line.trim())
          .filter(line => line !== '')
          .join('<br>');
    },
    /**
     * 从全部名称字符串中剔除当前名称，返回曾用名列表（数组）
     * @param {string} allName  - 逗号分隔的名称串，如 "老李水果店, 小李水果店"
     * @param {string} currentName - 当前名称，如 "小李水果店"
     * @returns {string[]} 曾用名数组，如 ["老李水果店"]
     */
    getAliasNames(allName, currentName) {
      if (!allName) return [];
      // 按逗号分割，去除首尾空格，过滤掉空字符串
      const names = allName.split(',').map(s => s.trim()).filter(Boolean);
      // 过滤掉与当前名称完全一致的项（不区分大小写可调整）
      return names.filter(name => name !== currentName);
    },
    /**
     * 获取用于展示的曾用名字符串（用顿号连接）
     */
    getAliasText(allName, currentName) {
      const aliases = this.getAliasNames(allName, currentName);
      return aliases.length ? aliases.join('、') : '';
    },

    // 生成全局唯一 key，避免 Duplicate keys
    genUniqueKey(prefix, id) {
      this.keyCounter += 1;
      return `${prefix}_${id || 'x'}_${this.keyCounter}`;
    },

    getTreeKey(row) {
      return (row && (row.uniqueKey || row.id)) || '';
    },

    getRowIndex(index, row) {
      // 加载更多占位行：不显示序号
      if (row.isLoadMore) return '';
      // 商户行：用 fetchList 时分配的跨页递增序号
      if (!row.isStore) {
        return row.rowNo;
      }
      // 门店行：父商户序号 + 门店序号（loadStorePage 时写入的 storeIndex）
      const mi = row.merchantRowNo || 1;
      const si = row.storeIndex || (index + 1);
      return mi + '-' + si;
    },

    setTableHeight() {
      if (typeof window !== 'undefined') {
        this.tableHeight = Math.round((window.innerHeight || document.documentElement.clientHeight) * 0.55) + 'px';
      }
    },

    fetchList() {
      this.tableLoading = true;
      pageQueryList({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        dataType: this.searchForm.wfType,
        keyword: this.searchForm.keyword,
        status: this.searchForm.status,
        timeField: this.searchForm.timeField,
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime,
        userRole: this.userRole,
        channelId: this.searchForm.channelId
      }).then(res => {
        if (res && res.code === '200') {
          this.total = res.data.total || 0;
          this.paginationKey = `${this.currentPage}-${this.pageSize}-${this.total}`
          this.tableData = (res.data.records || []).map((item, idx) => ({
            ...item,
            id: item.id || item.merchantId || ('M_' + idx),
            uniqueKey: 'M_' + (item.id || item.merchantId || item.merchantCreditCode) + '_' + idx,
            rowNo: (this.currentPage - 1) * this.pageSize + idx + 1,
            hasChildren: true,
            // 注意：不设置 children，lazy 模式下首次展开才会触发 loadNode
          }));
        } else {
          this.$message.error(res && res.message ? res.message : '查询失败');
          this.tableData = [];
          this.total = 0;
        }
      }).catch(() => {
        this.$message.error('查询失败，请稍后重试');
        this.tableData = [];
        this.total = 0;
      }).finally(() => {
        this.tableLoading = false;
      });
    },

    // 标准懒加载：点击商户展开箭头时调用，加载该商户下的门店（第一页）
    loadNode(node, treeNode, resolve) {
      this.loadStorePage(node, 1, 5, (stores) => {
        resolve(stores);
        this.$nextTick(() => {
          if (stores.some(s => s.isLoadMore)) {
            this.bindScrollObserver(node);
          }
        });
      });
    },

    // 加载指定页门店，若还有更多则在末尾追加"加载更多"占位行
    loadStorePage(node, pageNo, pageSize, callback) {
      subPageQuery({
        pageNo: pageNo,
        pageSize: pageSize,
        keyword: this.searchForm.keyword,
        status: this.searchForm.status,
        timeField: this.searchForm.timeField,
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime,
        merchantCode: node.merchantCreditCode,
        flowId: node.flowId,
        channelId: node.channelId
      }).then(res => {
        if (res && res.code === '200' && res.data) {
          const records = res.data.records || [];
          const total = res.data.total || 0;
          // 探测式判断：返回满一页说明可能还有更多（不依赖后端 total 字段）
          const hasMore = records.length >= pageSize;
          const base = (pageNo - 1) * pageSize;

          const stores = records.map((s, i) => ({
            ...s,
            id: s.storeId || s.id || ('store_' + (base + i)),
            uniqueKey: this.genUniqueKey('S', s.storeId || s.id || i),
            merchantId: node.id,
            merchantRowNo: node.rowNo,
            storeIndex: base + i + 1, // 门店序号（跨页连续）
            isStore: true,
            hasChildren: false,
            flowId: s.flowId || '',
            channelName: s.channelName || '',
            merchantName: s.storeName || '',
            merchantCreditCode: s.storeNo || '',
            saleModel: s.saleModel || '',
            region: s.region || '',
            regLocation: s.businessAddress || '',
            auditState: s.auditState || '',
            createTime: s.createTime || '',
            firstAuditDesc: s.firstAuditDesc || '',
            secondAuditDesc: s.secondAuditDesc || '',
          }));

          // 还有更多时，追加"继续加载"占位行（显示已加载条数）
          if (hasMore) {
            stores.push({
              id: 'load_more_' + node.id,
              uniqueKey: this.genUniqueKey('LOAD_MORE', node.id),
              merchantId: node.id,
              merchantRowNo: node.rowNo,
              isStore: true,
              isLoadMore: true,
              hasChildren: false,
              loading: false,
              loadedCount: base + records.length, // 已加载门店条数
            });
          }

          this.$set(this.storePageMap, node.id, { pageNo, pageSize, total, hasMore });
          callback(stores);
        } else {
          this.$set(this.storePageMap, node.id, { pageNo, pageSize, total: 0, hasMore: false });
          callback([]);
        }
      }).catch(() => {
        this.$set(this.storePageMap, node.id, { pageNo, pageSize, total: 0, hasMore: false });
        callback([]);
      });
    },

    // 滚动/点击触发：加载下一页门店并追加到 children
    loadMoreStores(loadMoreRow) {
      const rowId = loadMoreRow.merchantId;
      const merchantRow = this.tableData.find(r => r.id === rowId);
      const pageInfo = this.storePageMap[rowId];

      if (!merchantRow || !pageInfo || !pageInfo.hasMore) return;
      if (loadMoreRow.loading) {
        this.$message.info('门店加载中，请稍候...');
        return;
      }

      loadMoreRow.loading = true;
      const nextPage = pageInfo.pageNo + 1;

      this.loadStorePage(merchantRow, nextPage, pageInfo.pageSize, (newStores) => {
        loadMoreRow.loading = false;

        const treeKey = this.getTreeKey(merchantRow);
        const lazyTreeNodeMap = this.$refs.multipleTable.store.states.lazyTreeNodeMap;
        const currentChildren = lazyTreeNodeMap[treeKey] || [];

        // 移除旧的占位行，追加新门店（含新的占位行）
        const filtered = currentChildren.filter(c => !c.isLoadMore);
        const merged = [...filtered, ...newStores];

        this.$set(lazyTreeNodeMap, treeKey, merged);

        this.$nextTick(() => {
          if (newStores.some(s => s.isLoadMore)) {
            this.bindScrollObserver(merchantRow);
          } else {
            this.$message({ type: 'success', message: '该商户的门店已全部加载' });
          }
        });
      });
    },

    // 监听"加载更多"占位行进入视口，自动加载下一页
    bindScrollObserver(row) {
      const sentinelRef = 'sentinel_' + row.id;
      const el = this.$refs[sentinelRef] && this.$refs[sentinelRef][0];
      if (!el) return;

      if (this.observerMap[row.id]) {
        this.observerMap[row.id].disconnect();
      }

      const tableEl = this.$refs.multipleTable && this.$refs.multipleTable.$el;
      const scrollRoot = tableEl ? tableEl.querySelector('.el-table__body-wrapper') : null;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 触发一次后立即断开，避免连续自动加载抢占手动点击
            observer.disconnect();
            const loadMoreRow = (row.children || []).find(c => c.isLoadMore);
            if (loadMoreRow) {
              this.loadMoreStores(loadMoreRow);
            }
          }
        });
      }, {
        root: scrollRoot,
        rootMargin: '0px 0px 50px 0px',
        threshold: 0
      });

      observer.observe(el);
      this.$set(this.observerMap, row.id, observer);
    },

    merchantAuditStateText(state) {
      if (['6'].includes(state)) return '通过';
      if (['4', '7'].includes(state)) return '不通过';
      if (['1', '1-0', '1-1', '1-2', '3'].includes(state)) return '审核中';
      return state || '-';
    },

    merchantAuditStateTagType(state) {
      if (['6'].includes(state)) return 'success';
      if (['4', '7'].includes(state)) return 'danger';
      if (['1', '1-0', '1-1', '1-2', '3'].includes(state)) return 'warning';
      return 'info';
    },

    // 刷新数据：tableKey+1 强制重建表格，清空 ElementUI 树表内部缓存的展开/加载状态
    refreshList() {
      this.keyCounter = 0;
      this.tableKey += 1;
      Object.values(this.observerMap).forEach(obs => obs && obs.disconnect());
      this.observerMap = {};
      this.storePageMap = {};
      this.fetchList();
    },

    onSearch() {
      this.currentPage = 1;
      this.refreshList();
    },

    onReset() {
      this.searchForm = { keyword: '', channelId: '', wfType: '', status: '', timeField: '', startTime: '', endTime: '' };
      this.currentPage = 1;
      this.refreshList();
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.refreshList();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.refreshList();
    },

    handleExport() {
      this.$message({ type: 'info', message: '正在导出，请稍候...' });
      // 1. 打开全屏 loading
      const loadingInstance = this.$loading({
        lock: true,
        text: '正在生成 Excel，文件较大请耐心等待...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      exportExcel(this.searchForm, { responseType: 'blob' }).then(res => {
        // 从响应头解析文件名（后端 Content-Disposition: attachment; filename=xxx.xlsx）
        const contentDisposition = res.headers && res.headers['content-disposition'];
        let filename = '终审通过导出(含退出).xlsx';
        if (contentDisposition) {
          const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?(.+)/);
          if (match) {
            filename = decodeURIComponent(match[1].replace(/['"]/g, ''));
          }
        }

        const blob = new Blob([res.data || res], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);   // 必须先插入
        link.click();
        document.body.removeChild(link);   // 现在才能正常移除
        window.URL.revokeObjectURL(url);
        this.$message({ type: 'success', message: '导出成功' });
      }).catch( err => {
        console.log("导出失败", err)
        this.$message.error('导出失败，请稍后重试');
      }).finally(() => {
        // 2. 无论成功失败，都关闭 loading
        loadingInstance.close();
      });
    },

    viewMerchant(row) {
      this.$router.push({
        path: '/sys/merchant/view/' + row.flowId,
        query: {
          merchantName: row.merchantName,
          merchantCreditCode: row.merchantCreditCode,
          keyword: this.searchForm.keyword || '',
          channelId: this.searchForm.channelId || '',
          wfType: this.searchForm.wfType || '',
          status: this.searchForm.status || '',
          timeField: this.searchForm.timeField || '',
          startTime: this.searchForm.startTime || '',
          endTime: this.searchForm.endTime || '',
          currentPage: this.currentPage,
          pageSize: this.pageSize
        }
      });
    },

    /**
     * 格式化时间，去掉毫秒部分
     * @param {string} timeStr - 时间字符串，如 "2026-08-05 06:32:06.851"
     * @returns {string} - 格式化后的时间，如 "2026-08-05 06:32:06"
     */
    formatTime(timeStr) {
      if (!timeStr) return '-';
      // 取小数点前面的部分
      return timeStr.toString().split('.')[0];
    }
  }
};
</script>

<style scoped>
.flex-container { height: 100%; display: flex; flex-direction: column; text-align: left; }
.flex-header { flex-shrink: 0; background: #fff; padding-bottom: 12px; }
.search-form { margin-bottom: 16px; }
.flex-item { flex: 1; min-height: 0; display: flex; flex-direction: column; overflow: hidden; }
.table-wrapper { flex: 1; min-height: 0; overflow: hidden; }
.pagination-bar { text-align: right; padding: 8px 0; flex-shrink: 0; }

/* 滚动加载更多占位行 */
.load-more-cell {
  text-align: center;
  color: #409EFF;
  cursor: pointer;
  padding: 4px 0;
  position: relative;
}
.load-more-text { font-size: 12px; }
.sentinel {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}
/* 商户名称 + 曾用名角标 */
.merchant-name-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  overflow: hidden;
}

.merchant-name-cell > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}

.alias-tag {
  flex-shrink: 0;  /* 角标不被压缩 */
  cursor: pointer;
}

/* 流程状态双标签 */
.audit-state-group {
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: center;
}

/* 内容区样式 */
.audit-tip-plain {
  max-width: 500px;
  max-height: 240px;
  padding: 5px 8px;
  overflow-y: auto;
  line-height: 1.6;
  color: #303133;
  font-size: 12px;
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', sans-serif;
}

/* 自定义滚动条（WebKit 内核） */
.audit-tip-plain::-webkit-scrollbar {
  width: 6px;
}
.audit-tip-plain::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 3px;
}
.audit-tip-plain::-webkit-scrollbar-track {
  background: #f5f7fa;
  border-radius: 3px;
}

/* Tooltip 容器美化（需配合 popper-class） */
.audit-tooltip-popper {
  background: #ffffff !important;    /* 白底 */
  border: 1px solid #ebeef5;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 0;                        /* 内边距由内容区控制 */
}
</style>
